import React from 'react';
import { Link } from 'react-router-dom';
import './AstroCTA.css';

// Composant pour le calcul du thème natal
export const ThemeNatalCTA = () => {
  return (
    <div className="astro-cta panel exclude-from-toc">
      <div className="astro-cta-image theme-natal-image">
        <div className="image-overlay"></div>
      </div>
      <div className="astro-cta-content">
        <div className="astro-cta-title">Découvre ton thème astral complet</div>
        <p>
          Prêt à plonger plus profondément dans ton univers intérieur ? 
          Calcule gratuitement ton thème natal et révèle ce que les astres 
          racontent sur ta personnalité, tes dons cachés et ton chemin de vie.
        </p>
        <Link to="/calcul-theme-astral" className="astro-cta-button">
          Calculer mon thème natal
          <span className="icon">✨</span>
        </Link>
      </div>
    </div>
  );
};

// Composant pour la compatibilité amoureuse
export const CompatibiliteAmoureuseCTA = () => {
  return (
    <div className="astro-cta panel exclude-from-toc">
      <div className="astro-cta-image compatibility-image">
        <div className="image-overlay"></div>
      </div>
      <div className="astro-cta-content">
        <div className="astro-cta-title">Quelle est votre compatibilité amoureuse ?</div>
        <p>
          Les astres ont-ils prévu une histoire entre vous deux ? 
          Découvre si vos énergies sont en harmonie, quels défis vous 
          attendent et comment naviguer votre relation avec plus de conscience.
        </p>
        <Link to="/compatibilite-amoureuse-astrologie" className="astro-cta-button">
          Tester notre compatibilité
          <span className="icon">❤️</span>
        </Link>
      </div>
    </div>
  );
}; 